export default __webpack_public_path__ + "static/media/rm-white.1f998ea7.svg";